export function getYearFromDateString(dateString: string) {
  const year = dateString.split('-')[0];

  return year;
}
